import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type KpiConfig } from '../services/deviceKpiParameterService'

export interface KpiConfigState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  configs: KpiConfig[]
}

const initialState: KpiConfigState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  configs: []
}

const kpiConfigSlice = createSlice({
  name: 'kpiConfigurations',
  initialState,
  reducers: {
    kpiConfigLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        configs: []
      }
    },
    kpiConfigUpdateAction: (state, action: PayloadAction<{ data: KpiConfig[], httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        configs: action.payload.data
      }
    },
    kpiConfigErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        configs: []
      }
    },
    kpiConfigReset: () => initialState
  }
})

export const {
  kpiConfigLoadingAction,
  kpiConfigUpdateAction,
  kpiConfigErrorAction,
  kpiConfigReset
} = kpiConfigSlice.actions

export default kpiConfigSlice.reducer
